import React from "react";
import { useTranslation } from "react-i18next";

const NoTransactions = () => {
  const { t } = useTranslation();
  return <h3 style={{ color: "#4A76A1" }}>{t("no_transactions")}</h3>;
};

export default React.memo(NoTransactions);
